import {ComponentRegistry} from "./ComponentRegistry";

let registry: ComponentRegistry | null = null;

export function setComponentRegistry(r: ComponentRegistry) {
    registry = r;
}

export function getRegistry(): ComponentRegistry {
    if (!registry) {
        throw new Error('ComponentRegistry has not been set. Call setComponentRegistry(...) during app startup.');
    }
    return registry;
}
